import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DialogService } from '@eforall/dashboard';
import { AlgoliaSearchObject } from '@interfaces';
import { SearchDialog } from '../../../explorer/search-dialog/search.dialog';
import { AccApplicationDialog } from '../acc-application-dialog';
import { AccVentureDialog } from '../dialog/acc-venture/acc-venture.dialog';
import { PersonDialog } from '../person-dialog';

@Component({
	selector: 'search-widget',
	standalone: true,
	templateUrl: './search.widget.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: './search.widget.scss',
})
export class SearchWidget {

	private dialogService = inject(DialogService);
	public selectedRow: AlgoliaSearchObject | undefined;

	public async search() {

		const dialogAction = await this.dialogService.showCustom(SearchDialog, { data: { searchOnlyForPerson: false } }, 800, 800);
		if (!dialogAction || !dialogAction.callbackResult) return;

		this.selectedRow = dialogAction.callbackResult as AlgoliaSearchObject;

		if (dialogAction.id == 'explore' && this.selectedRow.id) {
			switch (this.selectedRow.objectType) {
				case 'Person':
					await this.dialogService.showCustom(PersonDialog, { data: { personId: this.selectedRow.id, toEdit: false } }, 800, 800);
					break;
				case 'AccApplication':
					await this.dialogService.showCustom(AccApplicationDialog, { data: { accApplicationId: this.selectedRow.id } }, 900, 900);
					break;
				case 'AccVenture':
					await this.dialogService.showCustom(AccVentureDialog, { data: { accVentureId: this.selectedRow.id } }, 700, 700);
					break;
			}
		}
	};

	async RefreshAlgoliaData() {
		//commented out to prevent accidental date refresh for now
		// const results = await this.func.algolia.saveObjects();
		console.log("Refresh Algolia Data");
	}

}